import { DefaultQueryParams, parseQuery } from '@pascal/pascal-core';
import { catchMeGameId, touchMeGameId } from '../../../enums/gameConstant';

export const ResourcesSharedNames = {
  bluePig: 'animations_web_characters_characters_bluePig_blue_pig',
  yellowPig: 'animations_web_characters_yellowPig_yellow_pig',
  redPig: 'animations_web_characters_redPig_red_pig',
  bluePigButton: 'animations_web_characters_characters_bluePigButton_blue_pig_front',
  yellowPigButton: 'animations_web_buttons_yellowPigButton_yellow_pig_front',
  redPigButton: 'animations_web_buttons_redPigButton_red_pig_front',
  wolf: 'animations_web_buttons_wolf_wolf',
  whiteWolf: 'animations_web_characters_whiteWolf_white_wolf',
  door: 'animations_web_door_door',
  backgroundFirst: 'assets_shared_background_scene1',
  backgroundSecond: 'assets_shared_background_scene2',
  backgroundThird: 'assets_shared_background_scene3',
  wall: 'assets_shared_wall',
};

export const catchMeResources = [
  {
    name: ResourcesSharedNames.backgroundFirst,
    path: 'assets/catchMe/background/background_scene1.png',
  },
  {
    name: ResourcesSharedNames.backgroundSecond,
    path: 'assets/catchMe/background/background_scene2.png',
  },
  {
    name: ResourcesSharedNames.backgroundThird,
    path: 'assets/catchMe/background/background_scene3.png',
  },
  { name: ResourcesSharedNames.wall, path: 'assets/catchMe/background/wall.png' },
  {
    name: ResourcesSharedNames.bluePig,
    path: 'animations/catchMe/web/characters/bluePig/blue_pig.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/catchMe/web/characters/bluePig/blue_pig.atlas',
      },
    },
  },
  {
    name: ResourcesSharedNames.yellowPig,
    path: 'animations/catchMe/web/characters/yellowPig/yellow_pig.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/catchMe/web/characters/yellowPig/yellow_pig.atlas',
      },
    },
  },
  {
    name: ResourcesSharedNames.redPig,
    path: 'animations/catchMe/web/characters/redPig/red_pig.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/catchMe/web/characters/redPig/red_pig.atlas',
      },
    },
  },
  {
    name: ResourcesSharedNames.bluePigButton,
    path: 'animations/catchMe/web/buttons/bluePigButton/blue_pig_front.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/catchMe/web/buttons/bluePigButton/blue_pig_front.atlas',
      },
    },
  },
  {
    name: ResourcesSharedNames.redPigButton,
    path: 'animations/catchMe/web/buttons/redPigButton/red_pig_front.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/catchMe/web/buttons/redPigButton/red_pig_front.atlas',
      },
    },
  },
  {
    name: ResourcesSharedNames.yellowPigButton,
    path: 'animations/catchMe/web/buttons/yellowPigButton/yellow_pig_front.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/catchMe/web/buttons/yellowPigButton/yellow_pig_front.atlas',
      },
    },
  },
  {
    name: ResourcesSharedNames.wolf,
    path: 'animations/catchMe/web/characters/wolf/wolf.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/catchMe/web/characters/wolf/wolf.atlas',
      },
    },
  },
  {
    name: ResourcesSharedNames.whiteWolf,
    path: 'animations/catchMe/web/characters/whiteWolf/white_wolf.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/catchMe/web/characters/whiteWolf/white_wolf.atlas',
      },
    },
  },
  {
    name: ResourcesSharedNames.door,
    path: 'animations/catchMe/web/door/door.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/catchMe/web/door/door.atlas',
      },
    },
  },
];

const touchMeResources = [
  {
    name: ResourcesSharedNames.backgroundFirst,
    path: 'assets/touchMe/background/background_scene1.png',
  },
  {
    name: ResourcesSharedNames.backgroundSecond,
    path: 'assets/touchMe/background/background_scene2.png',
  },
  {
    name: ResourcesSharedNames.backgroundThird,
    path: 'assets/touchMe/background/background_scene3.png',
  },
  { name: ResourcesSharedNames.wall, path: 'assets/touchMe/background/wall.png' },
  {
    name: ResourcesSharedNames.bluePig,
    path: 'animations/touchMe/web/characters/bluePig/blue_pig.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/touchMe/web/characters/bluePig/blue_pig.atlas',
      },
    },
  },
  {
    name: ResourcesSharedNames.yellowPig,
    path: 'animations/touchMe/web/characters/yellowPig/yellow_pig.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/touchMe/web/characters/yellowPig/yellow_pig.atlas',
      },
    },
  },
  {
    name: ResourcesSharedNames.redPig,
    path: 'animations/touchMe/web/characters/redPig/red_pig.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/touchMe/web/characters/redPig/red_pig.atlas',
      },
    },
  },
  {
    name: ResourcesSharedNames.bluePigButton,
    path: 'animations/touchMe/web/buttons/bluePigButton/blue_pig_front.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/touchMe/web/buttons/bluePigButton/blue_pig_front.atlas',
      },
    },
  },
  {
    name: ResourcesSharedNames.redPigButton,
    path: 'animations/touchMe/web/buttons/redPigButton/red_pig_front.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/touchMe/web/buttons/redPigButton/red_pig_front.atlas',
      },
    },
  },
  {
    name: ResourcesSharedNames.yellowPigButton,
    path: 'animations/touchMe/web/buttons/yellowPigButton/yellow_pig_front.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/touchMe/web/buttons/yellowPigButton/yellow_pig_front.atlas',
      },
    },
  },
  {
    name: ResourcesSharedNames.wolf,
    path: 'animations/touchMe/web/characters/wolf/wolf.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/touchMe/web/characters/wolf/wolf.atlas',
      },
    },
  },
  {
    name: ResourcesSharedNames.whiteWolf,
    path: 'animations/touchMe/web/characters/whiteWolf/white_wolf.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/touchMe/web/characters/whiteWolf/white_wolf.atlas',
      },
    },
  },
  {
    name: ResourcesSharedNames.door,
    path: 'animations/touchMe/web/door/door.json',
    config: {
      metadata: {
        spineAtlasFile: 'animations/touchMe/web/door/door.atlas',
      },
    },
  },
];

// const brandedGameMobileAnimation = {};

const brandedGameWebAnimation = {
  [catchMeGameId]: catchMeResources,
  [touchMeGameId]: touchMeResources,
};

const checkedResourcesByGameId = () => {
  const { [DefaultQueryParams.GameId]: gameId } = parseQuery(window.location.search);

  return brandedGameWebAnimation[gameId];
};

export const gameResources = checkedResourcesByGameId();
